import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import { productEnableDisable } from "../../redux/actions/productActions";
import "./productDetail.css";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorPopup from "../../components/popups/ErrorPopup";

const TableData = ({ data, index, currentPage, fetchProductList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [onEnableShow, setOnEnableShow] = useState(false);
  const handleClose = () => setOnEnableShow(false);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Product" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    dispatch(
      productEnableDisable(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    setOnEnableShow(false);
    fetchProductList();
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">{(currentPage - 1) * 10 + index}</td>
      <td className="table-each-row-data">{data?.product_id}</td>
      <td className="table-each-row-data">
        {data?.company_product_id
          ? data?.company_product_id.charAt(0).toUpperCase(0) +
            data?.company_product_id.slice(1)
          : "--"}
      </td>
      <td className="table-each-row-data">{data?.product_name}</td>
      <td className="table-each-row-data">{data?.vendorDivision?.name}</td>
      <td className="table-each-row-data table-each-row-data-color-green">
        {data.status ? (
          <span style={{ color: "#24D626" }}>Active</span>
        ) : (
          <span style={{ color: "red" }}>Inactive</span>
        )}
      </td>
      <td className="table-each-row-data">
        {data?.vendorDivision?.offer_type?.charAt(0).toUpperCase() +
          data?.vendorDivision?.offer_type?.slice(1)}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/product/view/${data.id}`)}
          >
            {"view"}
          </button>

          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() => navigate(`/product/edit/${data.id}`)}
              >
                {"edit"}
              </button>
              <span className="vr vr_line mt-1"></span>
              {data.status ? (
                <button
                  className="button-disable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Disable
                </button>
              ) : (
                <button
                  className="button-enable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Enable
                </button>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <EnableDisableModal
        show={onEnableShow}
        handleClose={handleClose}
        status={data?.status}
        title={`product - ${data?.product_id} ?`}
        id={data?.id}
        enableDisableFunc={enableDisableFunc}
      />
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </tr>
  );
};

export default TableData;
